import { render } from "./ActiveIssuesComponent.vue?vue&type=template&id=5781dd7e&scoped=true&ts=true"
import script from "./ActiveIssuesComponent.vue?vue&type=script&lang=ts"
export * from "./ActiveIssuesComponent.vue?vue&type=script&lang=ts"

import "./ActiveIssuesComponent.vue?vue&type=style&index=0&id=5781dd7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5781dd7e"]])

export default __exports__